import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React from "react";

import { ImageInfo } from "./ImageInfo";

export function BackgroundSelector(props: {
  value: string;
  onChange: (event: SelectChangeEvent) => void;
  possibleBackgroundImages: ImageInfo[];
}) {
  return (
    <FormControl sx={{ marginTop: "1rem" }}>
      <InputLabel id="demo-simple-select-filled-label">Background: </InputLabel>
      <Select
        autoWidth={true}
        labelId="background-target-label"
        id="background-target"
        value={props.value}
        label="Background: "
        onChange={props.onChange}
      >
        {props.possibleBackgroundImages.map((imageInfo) => {
          if (imageInfo.type === "src") {
            return (
              <MenuItem key={imageInfo.value} value={imageInfo.value}>
                {imageInfo.value}
              </MenuItem>
            );
          }
          return (
            <MenuItem key={imageInfo.name} value={imageInfo.name}>
              {imageInfo.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
